module.exports = __webpack_public_path__ + "img/LOGO.d2e804be.png";